import React from 'react';
import { History } from 'history';
import { Input, InputMoney, InputMultiline, InputSwitch, InputPicklist } from '../../components';
import BaseEdit from '../base/base-edit.component'; 
import Model from './transactionamount-model';  //editable..
import AmounttypeModel from '../amounttype/amounttype-model';
import AmounttypePicklist from '../amounttype/amounttype-picklist.component';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class TransactionamountEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        
        this.onChange = this.onChange.bind(this);
    }
    
    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onLoadAmounttype = (data: any) => {
        const value = AmounttypeModel.getCalcValue(data?.aspercentage, data?.value * data.calcsign, this.state.datarow.transactionTotaldetail)
        this.setState({ datarow: { ...this.state.datarow, 'amounttype': data?.id, 'amounttypeCaption': data?.name || '', 'value': value }  });
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) {

        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseEdit history={this.props.history} 
                model={Model} datarow={this.state.datarow} onLoad={this.onLoad} onError={this.onError}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                <InputPicklist name='amounttype' label='Type' value={this.state.datarow.amounttype} caption={this.state.datarow.amounttypeCaption} error={this.state.errors?.amounttype} onChange={this.onChange} >
                    <AmounttypePicklist currentId={this.state.datarow.amounttype} onLoad={this.onLoadAmounttype}/>
                </InputPicklist>
                <InputMoney name='value' label='Amount' value={this.state.datarow.value} error={this.state.errors?.value} onChange={this.onChange} />    
            </BaseEdit>
        );
    }
}